import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from "react-localize-redux";
import { marketingListActions } from '../../store/marketingListStore';
import OverviewContent from './overviewContent';
import classnames from 'classnames';

class OverviewWindow extends React.Component {
    render() {
        return <div className={classnames('marketing-root', 'modal-inner', { 'with-background': localStorage.locales_popup_header_style !== 'filled' })}>
            <div className='popup-filled-header'>
                <div><Translate id="MarketingList.Results.PreviewOfSubjects" /> <b>{this.props.translate("MarketingList.Common.Shortening")}{this.props.match.params.id}</b></div>
            </div>
            <div className={classnames('modal-inner-content', 'with-background')} style={{ borderBottomLeftRadius: '0px', position: 'relative' }}>
                <OverviewContent requestId={parseInt(this.props.match.params.id)} exportId={parseInt(this.props.match.params.exportId)} />
            </div>
        </div>
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.marketingList, user: state.userContext }),
    dispatch => bindActionCreators(Object.assign({}, marketingListActions), dispatch)
)(OverviewWindow)));
